import { Loader2 } from 'lucide-react'
import { cn } from '../lib/cn'

export interface LoaderProps {
  size?: 'sm' | 'md' | 'lg'
  label?: string
  className?: string
}

const SIZES = { sm: 'size-4', md: 'size-8', lg: 'size-12' } as const

export function Loader({ size = 'md', label = 'Loading', className }: LoaderProps) {
  return (
    <span
      role="status"
      aria-live="polite"
      className={cn('inline-flex items-center gap-3', className)}
    >
      <Loader2 aria-hidden="true" className={cn('animate-spin text-momo-red', SIZES[size])} />
      <span className="sr-only">{label}</span>
    </span>
  )
}

/** Full-screen boot state for the kiosk, KDS and TV. */
export function FullscreenLoader({ label = 'Loading' }: { label?: string }) {
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-4 bg-surface">
      <Loader size="lg" label={label} />
      <p className="text-content-muted text-sm">{label}</p>
    </div>
  )
}

/** Skeleton block for menu grids while the catalog loads. */
export function Skeleton({ className }: { className?: string }) {
  return (
    <div
      aria-hidden="true"
      className={cn('animate-pulse rounded-lg bg-surface-overlay', className)}
    />
  )
}
